import { Route } from "react-router-dom"
import SiteMailoutForm from "site-mailouts/SiteMailoutForm"
import CourseMailoutForm from "courses/CourseMailoutForm"
import LessonMailoutForm from "lessons/LessonMailoutForm"

const customRoutes = [
  <Route exact path="/site-mailouts/mailout" component={SiteMailoutForm} />,
  <Route
    exact
    path="/courses/:courseId/mailout"
    component={CourseMailoutForm}
  />,
  <Route
    exact
    path="/lessons/:lessonId/mailout"
    component={LessonMailoutForm}
  />,
]

export default customRoutes
